import ReactDOM from "react-dom";
import "react-notifications/lib/notifications.css";

import compiler from "mson/lib/compiler";
import globals from "mson/lib/globals";
import moment from "moment-timezone";
import lookup from "country-code-lookup";

import { strings } from "./strings";
import customerForm from "./customerForm";
import { Log } from "./save";
import healthForm from "./health";
import * as cms from "./ro_all_cms";
import { NotificationContainer } from "react-notifications";
import AgentMarkHeader from "../components/AgentMarkHeader";

const nonCrew = {
  transiting: {
    text: "Visitor in Transit",
    form: "TransitForm",
    reason: "", // I've made a huge mistake
  },
  visitor: {
    text: "Visitor to Guam",
    form: "VisitorSpecificForm",
    reason: "TripReasonField", // I've made a huge mistake
  },
  resident: {
    text: "Returning Guam resident",
    form: "ResidentForm",
    reason: "ReturningReason",
  },
  intended_resident: {
    text: "Intended resident moving to Guam for at least one year",
    form: "IntendedResident",
    reason: "TripReasonField",
  },
};

const packingStrings = {
  AlcoholField: strings.alcoholLabel,
  AnimalProductsField: strings.animalProductsLabel,
  AnimalsField: strings.animalsLabel,
  CigarettesField: strings.cigarettesLabel,
  ExplosivesField: strings.explosivesLabel,
  FirearmsField: strings.firearmsLabel,
  PlantsField: strings.plantsLabel,
  ServiceAnimalField: strings.serviceAnimalLabel,
  SoilField: strings.soilLabel,
  SubstancesField: strings.substancesLabel,
};
// ExcisableGoodsField: strings.excisableGoodsLabel,
// PersonalGoodsField: strings.personalGoodsLabel,

const mark = compiler.newComponent({
  component: "Form",
  name: "app.MarkForm",

  fields: [
    {
      name: "CurrentForm",
      component: "CurrentForm",
    },
    // TextField("Mark the form as required"),
    ...customerForm().fields,
  ],
  listeners: [
    {
      event: "value",
      actions: [
        {
          component: "Emit",
          event: "FormData",
          value: "{{fields.CurrentForm.value}}",
        },
      ],
    },
  ],
});

const loadValues = async (data) => {
  const customerFormData = data["CustomerForm"];
  const packingList = data["PackingList"];
  const currencyValues = data["CurrencyVisitorCrewForm"];
  const declarationValues = data["DeclarationForm"];
  const resaleValues = data["ResaleForm"];
  const transitValues = data["TransitForm"];

  // reset the form on load
  for (let field of mark.getFields()) {
    if (field.getValue()) {
      field.setValue(null);
    }
  }
  for (let i = 1; i <= 8; i++) {
    mark.getField(`Divider${i}`).set({ hidden: true });
  }
  // pack up the health info
  let healthForms = [1, 2, 3, 4, 5, 6, 7, 8].map((i) => data[`HealthForm${i}`]);
  const HealthForm = healthForm(healthForms);
  HealthForm.forEach((form, i) => {
    i = i + 1;
    mark.getField(`Divider${i}`).set({ hidden: !form.name });
    mark.getField(`HealthName${i}`).setValue(form["name"]);
    mark.getField(`HealthCities${i}`).setValue(form["countries"]);
    mark.getField(`Address${i}`).setValue(form["address"]);
    mark.getField(`Telephone${i}`).setValue(form["phone"]);
    mark.getField(`Email${i}`).setValue(form["email"]);
    mark.getField(`SeatNo${i}`).setValue(form["seat"]);
    mark
      .getField(`Status${i}`)
      .setValue(
        form["status"] ? form["status"].toUpperCase().replace("_", " ") : null
      );
    mark.getField(`HealthUS${i}`).setValue(form["visitedUs"]);
    mark.getField(`HealthOther${i}`).setValue(form["visitedOther"]);
    mark.getField(`Fever${i}`).setValue(form["fever"]);
    let countryString = "";
    try {
      countryString = lookup.byIso(form["nationality"]).country;
    } catch (e) {
      countryString = form["nationality"];
    }
    mark.getField(`Nationality${i}`).setValue(countryString);
    mark.getField(`Workplace${i}`).setValue(form["workplace"]);
    mark.getField(`Occupation${i}`).setValue(form["occupation"]);
    mark.getField(`Symptoms${i}`).setValue(form["symptoms"]);
    mark.getField(`OtherSymptoms${i}`).setValue(form["otherSymptoms"]);
    let QuestionsText = null;
    if (form["questions"] && form["questions"].length) {
      QuestionsText = `
|          |         |
|:---------|:--------|`;
      let questions = form["questions"]
        .map((q) => {
          return `|${q["question"]}|${q["answer"]}|`;
        })
        .join(`\n`);
      QuestionsText = `${QuestionsText}\n${questions}`;
    }
    mark.getField(`QuestionsField${i}`).setValue(QuestionsText);
    mark.getField(`Medication${i}`).setValue(form["medication"]);
  });

  mark
    .getField("health-form-header")
    .set({ hidden: !HealthForm.filter((f) => f.name).length });

  let packingText = "";
  Object.keys(packingList).forEach((key) => {
    let packingString = packingStrings[key];
    if (packingList[key] && key !== "CrewType") {
      packingText = `${packingText}\n* ${packingString}\n`;
    }
  });
  if (packingText === "") {
    packingText = "N/A\n\n";
  }
  packingText = `${packingText}\nDescription of goods: ${declarationValues["GoodsDescription"]}\n***\n`;

  mark.getField("PackingListField").setValue(packingText);
  let TenKText = `
|  |  |
|--|--|
|${strings.over10kLabel}|`;
  if (currencyValues["10KField"]) {
    TenKText = `
${TenKText}TRUE|
`;
  } else {
    TenKText = `
${TenKText}FALSE|
`;
  }
  TenKText = `
${TenKText}|${strings.resaleLabel}|`;

  if (resaleValues["ResaleField"]) {
    const resaleCurrency = new Intl.NumberFormat().format(
      resaleValues["RemainField"]
    );
    TenKText = `
${TenKText}TRUE|
|Value: US$ ${resaleCurrency}||
`;
  } else {
    TenKText = `
${TenKText}FALSE|
`;
  }
  // ResaleText = `${ResaleText}\n***\n`
  mark.getField("DeclarationField").setValue(TenKText); // +ResaleText;

  // TODO: table of people
  mark.getField("TotalLabel").setValue(customerFormData["FamilyMembersField"]);
  let travelerTable = "";
  if (customerFormData["LastNameField1"]) {
    mark
      .getField("TravelersLabel")
      .setValue("Additional travelers covered by this form:");
    travelerTable = `
|Last Name|First Name|Middle|DOB|Gender|
|:--------|:---------|:-----|:--|:-----|`;
  } else {
    mark.getField("TravelersLabel").setValue("");
  }
  for (let i = 1; i < 8; i++) {
    if (customerFormData[`LastNameField${i}`]) {
      let DOBValue = `${customerFormData[`DOBDayField${i}`]}/${
        customerFormData[`DOBMonthField${i}`]
      }/${customerFormData[`DOBYearField${i}`]}`;
      travelerTable = `${travelerTable}\n|${
        customerFormData[`LastNameField${i}`]
      }|${customerFormData[`FirstNameField${i}`]}|${
        customerFormData[`MiddleNameField${i}`] || " "
      }|${DOBValue}`;
      travelerTable = `${travelerTable}|${customerFormData[
        `Gender${i}`
      ].toUpperCase()}|`;
    }
  }
  mark.getField("Travelers").setValue(travelerTable);
  // customer form stuff
  const originatingData = [
    customerFormData["OriginatingFromField"],
    customerFormData["OriginatingFromCityField"],
  ];

  const flightData = [customerFormData["Airline"], customerFormData["Flight"]]; // [airline,flightnumber]
  let flightAirline = "";
  const airlineRecords = await cms.getAirlines();
  let airlines = airlineRecords.data.listAirlines.items;
  flightAirline = airlines.find((v) => v.id === flightData[0]).name || " ";

  const originatingCountry = lookup.byIso(String(originatingData[0])).country;
  const originatingCity = String(originatingData[1] || " - ");

  const ArrivalValues = moment
    .tz(String(customerFormData["ArrivalDate"]), "Australia/Sydney")
    .toArray();

  const ArrivalDateData = `${ArrivalValues[1] + 1}/${ArrivalValues[2]}/${
    ArrivalValues[0]
  }`;
  // const ArrivalDateData = `${ArrivalValues[2]}/${ArrivalValues[1]+1}/${ArrivalValues[0]}`;
  const HomeCountry = strings.countryOptions.find(
    (v) => v.value === customerFormData["CountryOfOriginField"]
  ).label;
  let CityValue = customerFormData["CountryOfOriginFieldCity"];
  if (strings.cityStrings.find((v) => v.value === CityValue))
    CityValue = strings.cityStrings.find((v) => v.value === CityValue);
  const HomeCity = CityValue ? "/" + CityValue.label : "";
  // set fields for customer form stuff
  mark.getField("ArrivalDateField").setValue(ArrivalDateData);
  mark
    .getField("StatusField")
    .setValue(customerFormData["StatusField"].toUpperCase().replace("_", " "));
  mark
    .getField("AirlineField")
    .setValue(
      `${flightAirline || " - "}/${flightData[1] || " - "} / ${
        originatingCountry || " - "
      }/${originatingCity || " - "}`
    );
  mark.getField("SurnameField").setValue(customerFormData["LastNameField"]);
  mark.getField("FirstNameField").setValue(customerFormData["FirstNameField"]);
  mark
    .getField("MiddleNameField")
    .setValue(customerFormData["MiddleNameField"]);
  mark
    .getField("GenderField")
    .setValue(customerFormData["Gender"].toUpperCase());
  mark
    .getField("DOBField")
    .setValue(
      `${customerFormData["DOBDayField"]}/${customerFormData["DOBMonthField"]}/${customerFormData["DOBYearField"]}`
    );
  mark.getField("AddressOnGuam").setValue(customerFormData["AddressOnGuam"]);
  mark
    .getField("PassportField")
    .setValue(
      `${lookup.byIso(customerFormData["PassportCountryField"]).country} / ${
        customerFormData["PassportNoField"]
      }`
    );
  mark.getField("ResidenceField").setValue(`${HomeCountry}${HomeCity}`);
  if (!customerFormData["StatusField"].includes("crew/")) {
    // not a crew member - display visitor stuff
    // load the visitor data based on the status field using the nonCrew info above
    let formName = "";
    let visitorFormData = {};
    let statusValue = customerFormData["StatusField"];

    try {
      formName = nonCrew[statusValue].form;
      visitorFormData = data[formName];
    } catch (e) {}

    // common fields for all non crew travelers
    mark.getField("StatusTextField").setValue(nonCrew[statusValue].text);
    if (!statusValue.includes("transit")) {
      // I should have made the reason field have a common name. I am teh dumb.
      const reasonField = nonCrew[statusValue].reason;
      const reasonText = visitorFormData[reasonField]
        ? visitorFormData[reasonField]
        : "other";
      if (reasonText !== "other") {
        mark
          .getField("ReasonForTrip")
          .setValue(
            strings.reasonOptions.find((o) => o.value === reasonText).label
          );
      } else {
        mark.getField("ReasonForTrip").setValue("Other");
      }
    } else {
      mark
        .getField("FinalDestination")
        .setValue(transitValues["TransitFinalDestination"]);
    }
    // fields for non-resident visitors
    // if not a resident
    if (!statusValue.includes("resident")) {
      const stayString = visitorFormData["LengthOfStayField"];
      let stayValue = "";
      if (stayString) {
        stayValue = strings.lengthOptions.find(
          (o) => o.value === stayString
        ).label;
      } else {
        stayValue = "N/A";
      }
      mark.getField("LengthField").setValue(stayValue);

      const tripNumberString = visitorFormData["TripToGuamField"];
      let tripValue = "";
      if (tripNumberString) {
        tripValue = strings.tripOptions.find(
          (o) => o.value === tripNumberString
        ).label;
      } else {
        tripValue = "N/A";
      }
      mark.getField("TripField").setValue(tripValue);

      mark
        .getField("OnlineBooking")
        .setValue(
          visitorFormData["onlineBooking"]
            ? visitorFormData["onlineBooking"]
            : "N/A"
        );

      const arrangementsString = visitorFormData["TravelArrangementsField"];
      let arrangementsValue = "";
      if (arrangementsString) {
        arrangementsValue = strings.arrangementOptions.find(
          (o) => o.value === arrangementsString
        ).label;
      } else {
        arrangementsValue = "N/A";
      }
      mark.getField("Arrangements").setValue(arrangementsValue);

      const places = [
        "bandb",
        "friends",
        "hotel",
        "military",
        "other",
        "rental",
        "ship",
        "timeshare",
      ];
      let placesString = "";
      places.forEach((place) => {
        const placeString = strings.stayOptions.find(
          (f) => f.value === place
        ).label;
        if (visitorFormData[`${place}Field`])
          placesString = `${placesString}, ${placeString}`;
      });
      if (placesString === "") {
        placesString = "N/A";
      } else {
        placesString = placesString.substring(1);
      }
      mark.getField("PlaceOfStay").setValue(placesString);
    }
  }
};

mark.on("load", async () => {
  // wrap the emitting of data in a promise so it only fires once
  new Promise((resolve) => {
    mark.on("FormData", (formContext) => {
      resolve(formContext.form);
    });
  }).then(async (formData) => {
    if (!formData) {
      globals.redirect("/");
    } else {
      loadValues(formData);
      window.setTimeout(function () {
        Array.from(document.querySelectorAll("td"))
          .filter((el) => el.textContent === "TRUE")
          .map((t) => (t.style.color = "red"));
        Array.from(document.querySelectorAll("td"))
          .filter((el) => el.textContent === "YES")
          .map((t) => (t.style.color = "red"));
      }, 0);
      if (globals._path && globals._path !== "/wat") await Log(); // record this view as a "Log" - will need badge and ID to be loaded first for this to work properly

      const notifier = <NotificationContainer />;
      ReactDOM.render(notifier, document.getElementById("app"));

      const passengerCount = formData["CustomerForm"]["FamilyMembersField"];
      const agentHeader = <AgentMarkHeader passengerCount={passengerCount} />;
      ReactDOM.render(agentHeader, document.getElementById("app"));

      // ReactDOM.render(markPage, document.getElementById("app"));
    }
  });
});

export default mark;
